import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\GetCompanyByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyByIdController.php
* @route '/api/company/{company}'
*/
const GetCompanyByIdController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyByIdController.url(args, options),
    method: 'get',
})

GetCompanyByIdController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\GetCompanyByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyByIdController.php
* @route '/api/company/{company}'
*/
GetCompanyByIdController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetCompanyByIdController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\GetCompanyByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyByIdController.php
* @route '/api/company/{company}'
*/
GetCompanyByIdController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\GetCompanyByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyByIdController.php
* @route '/api/company/{company}'
*/
GetCompanyByIdController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCompanyByIdController.url(args, options),
    method: 'head',
})

export default GetCompanyByIdController